module.exports = __webpack_public_path__ + "img/whatsapp-icon.1586ba3c.svg";